import { getCallTypeColor } from "utils/cargoActionUtils";
import { intl } from "LocaleWrapper";
import { Tag, TagProps, TagSize } from "@cofano/cck";
import { CallType } from "__generated__/enums";

const CargoActionTypeTag = ({ type, ...props }: {
	type: CallType,
} & Omit<TagProps, "color" | "text">) => {
	return (
		<Tag
			color={getCallTypeColor(type)}
			text={intl.formatMessage({ id: type })}
			size={TagSize.NORMAL}
			{...props}
		/>
	);
};

export default CargoActionTypeTag;
